/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Hotline(props) {
    return (
        <SvgIcon {...props}>
            <path d="M8.305,8.513L7.598,9L6.49,9.688L3.449,4.772l0.914-0.537l1.051-0.5l-2.3-3.801L2.54,0.244 c0,0-3.094,1.406-2.452,4.474c1.154,5.51,5.366,8.431,5.366,8.431s2.096,1.679,4.971,0.128L11,12.966L8.305,8.513z" />
        </SvgIcon>
    );
}

Hotline.defaultProps = {
    viewBox: '0 0 11 16'
};

export default Hotline;
